import React from 'react';
import { IconProps } from '../types/types';

const RBIF: React.FC<IconProps> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104.46 150.06" role="img" {...props}><defs><style dangerouslySetInnerHTML={{__html: `.cls-1{fill:#0096f2}`}}/></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path className="cls-1" d="M31.2 0h9.5v150.06H0S31.2 140.59 31.2 0ZM73.26 0h-9.5v150.06h40.7S73.26 140.59 73.26 0Z"/></g></g></svg>
);

export default RBIF;
